// Sentiment/score scale stops (negative → neutral → positive) shared by the
// color pipes. The light neutral is a warmer take on the brand yellow
// (#f6d500), which is unreadable as text on white.
export const SCORE_SCALE_DARK = ['#dd001a', '#f6d500', '#3dac00'];
export const SCORE_SCALE_LIGHT = ['#a71717', '#FFBB3E', '#009e00'];
